import { render, staticRenderFns } from "./svgMyket.vue?vue&type=template&id=f4220b56&scoped=true"
import script from "./svgMyket.vue?vue&type=script&lang=js"
export * from "./svgMyket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4220b56",
  null
  
)

export default component.exports